import React from "react";
import PropTypes from "prop-types";
import DispatchPriorityGlobal from '../DispatchPrioritization/globalView/dispatchPriorityGlobal';

const UnloadingPriorityLossToAction = ({sideViewTab}) => {
    return (
        
        <DispatchPriorityGlobal sideViewTab={sideViewTab}/>
        
    );
};

UnloadingPriorityLossToAction.propTypes = {
    sideViewTab: PropTypes.string,
};

export default UnloadingPriorityLossToAction;